export default __webpack_public_path__ + "static/media/Rocket.9cf82211.svg";